// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2VIFf","col":"Table_col__1xl7i","fulfillmentStatus":"Table_fulfillmentStatus__Ct0-p","emailCol":"Table_emailCol__LfB_I"};